<template>
  <div id="app" class="app">
    <transition name="fade">
      <div id="page" v-if="pageLoaded" class="page">
        <transition name="fade">
          <Menu
            v-if="menuVisible"
            :currency="currency"
            :currencyValue="currencyValue"
            :currencyCode="currencyCode"
            @setAmount="setAmount"
            @scrollToSection="scrollToSection"
            @changeCurrency="changeCurrency"
            @openSellSkins="handleSellSkinsClick"
          />
        </transition>

        <div
          class="mob menu-icon"
          :class="{ active: menuVisible }"
          @click="toggleMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        <Header
          :currency="currency"
          :currencyValue="currencyValue"
          :currencyCode="currencyCode"
          @setAmount="setAmount"
          @scrollToSection="scrollToSection"
          @changeCurrency="changeCurrency"
          @openSellSkins="handleSellSkinsClick"
        />

        <router-view
          :currency="currency"
          :currencyCode="currencyCode"
          :isAuth="isAuth"
          :profileData="profileData"
          :settings="settings"
          @setAmount="setAmount"
          @topUp="topUp"
          @formatDate="formatDate"
          @openProductModal="openProductModal"
          @openSignInModal="openSignInModal"
          @refreshProfile="getProfileData"
        />

        <Footer @goToPage="goToPage" />

        <transition name="fade">
          <ProductModal
            v-if="productModalIsVisible"
            :currency="currency"
            @closeProductModal="closeProductModal"
          />
        </transition>

        <transition name="fade">
          <ComingSoonModal
            v-if="comingSoonModalIsVisible"
            @close="closeComingSoonModal"
          />
        </transition>

        <transition name="fade">
          <Login
            v-if="signInModalIsVisible"
            @closeSignInModal="closeSignInModal"
            @login2="login2"
          />
        </transition>

        <transition name="fade">
          <TopUpModal
            v-if="topUpModalIsVisible"
            :currency="currency"
            :currencyCode="currencyCode"
            @setTopUpAmount="setTopUpAmount"
          />
        </transition>

        <transition name="fade">
          <OrderModal
            v-if="orderModalIsVisible"
            :currency="currency"
            @topUp="topUp"
          />
        </transition>

        <transition name="fade">
          <AgeModal v-if="ageModalIsVisible" />
        </transition>

        <div v-if="cookesModalIsVisible" class="modal-overlay">
          <div class="cookies-modal">
            <div class="title">Cookies Unwrapped</div>

            <div class="desc">
              We use cookies to enhance your experience on our website.
              Essential cookies are necessary for basic operations and are set
              by default. We also employ additional cookies for various purposes
              that enhance your experience but are not required for core
              functions. You can adjust your cookie settings at any time. For
              more details, please refer to our Cookie Notice.

              <a class="desc" @click="goToPage('cookie')"> Cookie Notice </a>.
            </div>

            <button class="button" @click="acceptCookies">Ok, got it!</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { loadScriptsFromString } from '@/utils/load_scripts'
import { scroller } from 'vue-scrollto/src/scrollTo'
import AgeModal from './components/AgeModal.vue'
import ComingSoonModal from './components/ComingSoonModal.vue'
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'
import Login from './components/Login.vue'
import Menu from './components/Menu.vue'
import OrderModal from './components/OrderModal.vue'
import ProductModal from './components/ProductModal.vue'
import TopUpModal from './components/TopUpModal.vue'

export default {
  name: 'app',

  components: {
    Header,
    Menu,
    Footer,
    ProductModal,
    Login,
    TopUpModal,
    OrderModal,
    AgeModal,
    ComingSoonModal,
  },

  data() {
    return {
      ageModalIsVisible: true,
      comingSoonModalIsVisible: false,

      pageLoaded: false,
      heroImagesLoaded: false,
      menuVisible: false,

      isAuth: false,

      error: '',
      successMessage: '',

      orderHistory: [],
      depositHistory: [],

      textPageTitle: '',
      textPageHeader: '',
      textPageContent: '',
      textPageList: '',

      imgDomain: '',

      currency: '',
      currencyValue: '',
      currencyCode: '',
      currencyOptions: [],

      hostname: '',

      productModalIsVisible: false,
      chosenProoduct: {},

      profileData: {},
      countryOptions: [],

      amount: null,
      socials: [],

      analyticsInitialized: false,

      settings: {},

      signInModalIsVisible: false,
      topUpModalIsVisible: false,
      orderModalIsVisible: false,

      topUpAmount: '',

      ip: '',
      port: '',

      cookesModalIsVisible: false,

      faq: [
        {
          question: 'How do I purchase items from the shop?',
          answer:
            'To purchase items, simply browse our shop, select the items you want, and follow the checkout process. We accept various payment methods for your convenience.',
        },
        {
          question: 'How do I purchase items from the shop?',
          answer:
            'To purchase items, simply browse our shop, select the items you want, and follow the checkout process. We accept various payment methods for your convenience.',
        },
        {
          question: 'How do I purchase items from the shop?',
          answer:
            'To purchase items, simply browse our shop, select the items you want, and follow the checkout process. We accept various payment methods for your convenience.',
        },
        {
          question: 'How do I purchase items from the shop?',
          answer:
            'To purchase items, simply browse our shop, select the items you want, and follow the checkout process. We accept various payment methods for your convenience.',
        },
      ],

      activePackId: '',
    }
  },

  watch: {
    $route() {
      window.scrollTo(0, 0)
      this.closeMenu()

      if (this.isAuth) {
        this.getProfileData()
      }
    },
  },

  computed: {
    minOrderAmount() {
      return this.settings && this.settings.min_order_amount
    },

    payoutMethods() {
      const methods = this.settings && this.settings.payout_methods

      if (Array.isArray(methods)) {
        return methods
      }

      if (methods && typeof methods === 'object') {
        return Object.values(methods)
      }

      return []
    },

    sellingEnabled() {
      const enabled =
        this.settings &&
        (this.settings.payout_enabled === true ||
          this.settings.payout_enabled === 1 ||
          this.settings.payout_enabled === '1')

      const hasMethod = this.payoutMethods.some(
        (method) => method === 'card' || method === 'sepa',
      )

      return enabled && hasMethod
    },
  },

  methods: {
    // SELL SKINS

    handleSellSkinsClick() {
      this.closeMenu()
      this.openSellSkins()
    },

    openSellSkins() {
      // Keep the original payout availability safeguard.
      if (!this.sellingEnabled) {
        this.openComingSoonModal()
        return
      }

      if (!this.isAuth) {
        this.openSignInModal()
        return
      }

      if (this.$route.path !== '/sell-skins') {
        this.$router.push('/sell-skins')
      }
    },

    // COMING SOON MODAL

    openComingSoonModal() {
      this.comingSoonModalIsVisible = true
    },

    closeComingSoonModal() {
      this.comingSoonModalIsVisible = false
    },

    // AGE MODAL

    closeAgeModal() {
      this.ageModalIsVisible = false
    },

    // FAQ

    getFaq() {
      this.$http
        .get(process.env.VUE_APP_API + 'faq')
        .then((res) => {
          this.faq = res.data.payload
        })
        .catch(() => {})
    },

    // COOKIES

    cookiesModal() {
      const cookiesAccepted = localStorage.getItem('cookiesAccepted')

      if (!cookiesAccepted) {
        this.cookesModalIsVisible = true
      }
    },

    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true')
      this.cookesModalIsVisible = false
    },

    // TOP UP AND ORDERS

    setTopUpAmount(amount, packId) {
      this.topUpAmount = amount
      this.activePackId = packId
      this.openOrderModal()
    },

    closeOrderModal() {
      this.orderModalIsVisible = false
    },

    openOrderModal() {
      this.topUpModalIsVisible = false
      this.orderModalIsVisible = true
    },

    closeTopUpModal() {
      this.topUpModalIsVisible = false
    },

    openTopUpModal() {
      this.orderModalIsVisible = false
      this.topUpModalIsVisible = true
    },

    topUp(data) {
      this.error = ''

      this.$http
        .post(process.env.VUE_APP_API + 'payments/checkout', data)
        .then((res) => {
          if (res.data.status === 'OK' && res.data.redirect_url) {
            window.location = res.data.redirect_url
          } else {
            this.error = res.data.message || 'Unable to start checkout.'
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.openSignInModal()
          } else {
            this.error =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              'Unable to start checkout.'
          }
        })
    },

    // AUTHENTICATION

    login2() {
      this.error = ''

      this.$http
        .post(process.env.VUE_APP_API + 'user/fake-login')
        .then((res) => {
          if (res.data.status === 'OK') {
            this.isAuth = true
            this.getProfileData()
          }
        })
        .catch(() => {})
    },

    closeSignInModal() {
      this.signInModalIsVisible = false
    },

    openSignInModal2() {
      this.signInModalIsVisible = true
    },

    openSignInModal() {
      window.location.replace('https://api.vaulthex.com/auth/steam/redirect')
    },

    logout() {
      this.$http
        .get(process.env.VUE_APP_API + 'user/logout')
        .then(() => {
          this.isAuth = false
          this.profileData = {}
          this.orderHistory = []
          this.depositHistory = []

          if (this.$route.path !== '/') {
            this.$router.push({ path: '/' })
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.isAuth = false
            this.profileData = {}
          }
        })
    },

    // GENERAL UI

    setAmount(am) {
      this.amount = am
    },

    closeProductModal() {
      this.productModalIsVisible = false
    },

    openProductModal(product) {
      this.productModalIsVisible = true
      this.chosenProoduct = product
    },

    scrollToSection(section) {
      if (this.$route.name !== 'Home') {
        this.$router.push({ path: '/' })
      }

      setTimeout(() => {
        const firstScrollTo = scroller()
        firstScrollTo(section)
      }, 200)
    },

    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1,
      )
    },

    closeMenu() {
      this.menuVisible = false
      document.body.style.overflow = 'auto'
    },

    toggleMenu() {
      this.menuVisible = !this.menuVisible
      window.scrollTo(0, 0)

      document.body.style.overflow = this.menuVisible ? 'hidden' : 'auto'
    },

    menuHeight() {
      const doc = document.documentElement

      doc.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },

    // HISTORY

    getDepositHistory() {
      this.$http
        .get(process.env.VUE_APP_API + 'payments/history')
        .then((res) => {
          this.depositHistory = res.data.data
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.isAuth = false
          }
        })
    },

    getOrderHistory() {
      this.$http
        .get(process.env.VUE_APP_API + 'orders/history')
        .then((res) => {
          this.orderHistory = res.data.data
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.isAuth = false
          }
        })
    },

    formatDate(num) {
      const objectDate = new Date(num * 1000)

      let day = objectDate.getDate()
      if (day < 10) {
        day = '0' + day
      }

      let month = objectDate.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }

      const year = objectDate.getFullYear()

      function padTo2Digits(x) {
        return String(x).padStart(2, '0')
      }

      const hoursAndMinutes =
        padTo2Digits(objectDate.getHours()) +
        ':' +
        padTo2Digits(objectDate.getMinutes())

      return day + '.' + month + '.' + year + ' ' + hoursAndMinutes
    },

    // PRODUCT AND STATIC PAGES

    openProduct(item) {
      this.$router.push({
        path: '/products/' + item.id,
        params: { data: item.id },
      })

      this.getProductPageContent(item.id)
    },

    goToPage(item) {
      let newItem

      if (item === 'privacy') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('privacy')) {
            newItem = this.textPageList[i].id
          }
        }
      } else if (item === 'terms') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('terms')) {
            newItem = this.textPageList[i].id
          }
        }
      } else if (item === 'cookie') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('cookie')) {
            newItem = this.textPageList[i].id
          }
        }
      } else {
        newItem = item
      }

      this.$router.push({
        path: '/pages/' + newItem,
        params: { data: newItem },
      })

      this.getTextPageContent(newItem)
    },

    getTextPageContent(id) {
      this.textPageTitle = ''
      this.textPageHeader = ''
      this.textPageContent = ''

      this.$http
        .get(process.env.VUE_APP_API + 'static-pages/' + id)
        .then((res) => {
          this.textPageTitle = res.data.payload.title
          this.textPageContent = res.data.payload.content
          this.textPageHeader = res.data.payload.header
        })
        .catch(() => {})
    },

    // SETTINGS

    getSettings() {
      return this.$http
        .get(process.env.VUE_APP_API + 'settings')
        .then(async (res) => {
          const payload = res.data.payload || {}

          this.ip = payload.game_server && payload.game_server.host

          this.port = payload.game_server && payload.game_server.port

          this.settings = payload

          const snippet = payload.google_tag

          if (!this.analyticsInitialized && snippet) {
            await loadScriptsFromString(snippet)
            this.analyticsInitialized = true
          }
        })
        .catch(() => {})
    },

    getTextPages() {
      this.$http
        .get(process.env.VUE_APP_API + 'static-pages')
        .then((res) => {
          this.textPageList = res.data.payload
        })
        .catch((error) => {
          console.log(error)
        })
    },

    getSocials() {
      this.$http
        .get(process.env.VUE_APP_API + 'social-links')
        .then((res) => {
          this.socials = res.data.payload
        })
        .catch((error) => {
          console.log(error)
        })
    },

    // PROFILE

    getProfileData() {
      return this.$http
        .get(process.env.VUE_APP_API + 'user/profile')
        .then((res) => {
          this.profileData = res.data.payload || {}

          this.getOrderHistory()
          this.getDepositHistory()

          return this.profileData
        })
        .catch(() => {})
    },

    // CURRENCIES

    getCurrencies() {
      return this.$http
        .get(process.env.VUE_APP_API + 'currencies')
        .then((res) => {
          this.currencyOptions = res.data.payload || []

          if (!this.currencyOptions.length) {
            return
          }

          const savedCurrency = localStorage.getItem('currency')

          const selected = savedCurrency
            ? this.currencyOptions.find((item) => item.code === savedCurrency)
            : null

          const currency = selected || this.currencyOptions[0]

          this.currencyCode = currency.code
          this.currency = currency.symbol
          this.currencyValue = currency.value
        })
        .catch(() => {})
    },

    changeCurrency(item) {
      this.currencyCode = item
      localStorage.setItem('currency', item)
      this.checkCurrency()
    },

    checkCurrency() {
      const currency = this.currencyOptions.find(
        (item) => item.code === this.currencyCode,
      )

      if (currency) {
        this.currency = currency.symbol
        this.currencyValue = currency.value

        if (this.isAuth) {
          this.getProfileData()
        }
      }
    },
  },

  mounted() {
    if (localStorage.getItem('age')) {
      this.ageModalIsVisible = false
    }

    this.getFaq()
    this.cookiesModal()

    this.pageLoaded = true

    setTimeout(() => {
      this.heroImagesLoaded = true
    }, 1000)

    this.hostname = this.getDomainName(window.location.hostname)

    this.currency = process.env.VUE_APP_CURRENCY
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN

    window.addEventListener('resize', this.menuHeight)

    this.getSettings()
    this.menuHeight()
    this.getTextPages()
    this.getSocials()
    this.getCurrencies()

    this.$http
      .get(process.env.VUE_APP_API + 'user/is-auth')
      .then((res) => {
        this.isAuth = Boolean(res.data.authenticated)

        if (this.isAuth) {
          this.getProfileData()
        }
      })
      .catch(() => {
        this.isAuth = false
      })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.menuHeight)
    document.body.style.overflow = 'auto'
  },
}
</script>
